var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add list"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.5 10.0013L7.5 10.0013M17.5 5.0013L7.5 5.0013M17.5 15.0013H15M15 17.5013V15.0013M15 15.0013V12.5013M15 15.0013H12.5M4.16667 10.0013C4.16667 10.4615 3.79357 10.8346 3.33333 10.8346C2.8731 10.8346 2.5 10.4615 2.5 10.0013C2.5 9.54107 2.8731 9.16797 3.33333 9.16797C3.79357 9.16797 4.16667 9.54107 4.16667 10.0013ZM4.16667 5.0013C4.16667 5.46154 3.79357 5.83464 3.33333 5.83464C2.8731 5.83464 2.5 5.46154 2.5 5.0013C2.5 4.54106 2.8731 4.16797 3.33333 4.16797C3.79357 4.16797 4.16667 4.54106 4.16667 5.0013ZM4.16667 15.0013C4.16667 15.4615 3.79357 15.8346 3.33333 15.8346C2.8731 15.8346 2.5 15.4615 2.5 15.0013C2.5 14.5411 2.8731 14.168 3.33333 14.168C3.79357 14.168 4.16667 14.5411 4.16667 15.0013Z",
    stroke: "#0969DA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddList);
export default __webpack_public_path__ + "static/media/add-list.f21ffc3113c803ba46ad7e462e1992ea.svg";
export { ForwardRef as ReactComponent };